/*
 * Public API Surface of ibd-angular-components
 */

export * from './lib/ibd-angular-components.service';
export * from './lib/ibd-angular-components.component';
export * from './lib/ibd-angular-components.module';
